import { LIST_WIDTH } from 'utils/constants/listview';

export const columns = [
  {
    headerName: 'Emergency ID',
    field: 'ref',
    width: LIST_WIDTH.HUMAN_READABLE_ID,
  },
  {
    headerName: 'Status',
    field: 'status',
    width: LIST_WIDTH.STATUS,
    cellRenderer: 'convertEventStatus',
  },
  {
    headerName: 'Initiator full name',
    field: 'distressee_name',
    width: LIST_WIDTH.HUMAN_NAME,
  },
  {
    headerName: 'Initiator phone',
    field: 'distressee_phone',
    width: LIST_WIDTH.PHONE_NUMBER,
  },
  {
    headerName: 'Responder full name',
    field: 'responder_name',
    width: LIST_WIDTH.HUMAN_NAME,
  },
  {
    headerName: 'Responder phone',
    field: 'responder_phone',
    width: LIST_WIDTH.PHONE_NUMBER,
  },
  {
    headerName: 'Created At',
    field: 'created_at',
    width: LIST_WIDTH.TIME_DATE,
  },
  {
    field: 'departments',
    headerName: 'Departments',
    width: LIST_WIDTH.sm,
  },
];
